import { RootState } from '../../store';

export const getReportsFetchInfo = (state: RootState) =>
  state.reportsList.fetched;
export const getReportsState = (state: RootState) =>
  state.reportsList.reportsList;
